
<div class="audio-tracks" ref="root">
  <div
    class="audio-tracks-scroll"
    ref="scrollContainer"
    :style="`overflow: hidden; white-space: nowrap; height: 100%;`"
  >
    <!-- Left padding = half screen so time 0 starts at center (same as BR) -->
    <div :style="`width: ${halfScreen}px; display: inline-block; height: 100%;`"></div>
    <!-- Timeline at same scale as BR -->
    <div
      class="audio-timeline"
      :style="`width: ${timelineWidth}px; display: inline-block; position: relative; height: 100%;`"
    >
      <!-- One row per character -->
      <div
        v-for="(charSources, character) in groupedSources"
        :key="character"
        class="audio-track-row"
        :style="`height: ${trackHeight}px; position: relative; border-bottom: 1px solid #333;`"
      >
        <!-- Character label -->
        <span class="track-character-label" :style="{ color: charactersColors[character] || '#888' }">
          {{ character }}
        </span>
        <!-- Audio segments -->
        <div
          v-for="source in charSources"
          :key="source.id"
          class="audio-segment"
          :style="{
            position: 'absolute',
            left: (source.start * pxPerSec) + 'px',
            width: ((source.end - source.start) * pxPerSec) + 'px',
            height: '100%',
            backgroundColor: hexToRgba(charactersColors[character] || '#6449D1', 0.6),
            borderRadius: '3px',
            border: '1px solid ' + (charactersColors[character] || '#6449D1'),
          }"
          :title="`${source.character} — ${source.start.toFixed(1)}s → ${source.end.toFixed(1)}s`"
        >
          <div class="segment-label">{{ source.character }}</div>
        </div>
      </div>
    </div>
    <!-- Right padding -->
    <div :style="`width: ${halfScreen}px; display: inline-block; height: 100%;`"></div>
  </div>
</div>
